import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Impact() {
  return (
    <section className="impect_bg p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>The Business Impact of HDE App</h2>
            <p>
              While the current growth rate in the auction industry is 8.1%, the
              projected annualized growth is 12%, which means more users will
              enter the auction business net with the provision of a secure and
              effective video catalog platform.
            </p>
            <p>
              The app is an ideal platform to capture the 48% of users who
              wanted a secure platform. Users can seamlessly manage their
              auction (in fact, ecommerce businesses) from one dashboard. With
              new product niches and omnichannel payment features, HDE is all
              set to capture the video commerce industry in 2021 and beyond.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/hde/Tek_img_04.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1600}
                height={586}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Impact;
